var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"linkedbutton",attrs:{"role":"button","tabindex":"0","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.toplabel))])}
var staticRenderFns = []

export { render, staticRenderFns }